'SalesList'.list({expose: true, icon: 'FileInvoiceDollar'})
'Sales and Invoices'.title()
'Back'.action({act: 'cancel'})
'Refresh'.action({act: "refresh"})
'Download to Excel'.action({act: 'excel'})
'Unpaid Invoices'.action({spec: 'UnpaidInvoices.js'})
'Show Older Sales'.action({spec: 'SalesListAll.js'})

'order_items'.datatype()
'order_date'.field()
'theOrder'.field({showAsLink: true})
'billingNameAndCompany'.field({caption: "Customer"})
'productUniqueName'.field({caption: 'Product', showAsLink: true})
'_qty'.field()
'_line_total'.field({caption: "Amount Ex Tax"})
'_line_tax'.field()
'niceOrderStatus'.field({caption: "Status"})
'_date_completed'.field()
'View Order'.action({spec: 'ViewSalesOrder.js', place: 'row', act: 'editParent'})

'SalesList'.defaultSort({field: 'order_date', descending: true})

'SalesList'.limitToSubset('RecentOrActive')

'theOrder'.destination(async orderItem => {
  let dt = 'orders'
  if ( orderItem.onlyHoldsSubset('RecentOrActive') )
    dt += '.RecentOrActive'
  let res = await dt.bringSingle({id: orderItem.theOrder.id})
  return res
})
